// src/router/index.js
// 1. 把 createWebHashHistory 改回 createWebHistory（核心改动）
import { createRouter, createWebHistory } from 'vue-router'

// 导入页面组件（无需修改）
const index = () => import('@/views/index')
const news = () => import('@/views/news')
const newsshow = () => import('@/views/newsshow')
const service = () => import('@/views/service')
const strength = () => import('@/views/strength')
const about = () => import('@/views/about')
const contact = () => import('@/views/contact')
const swiper = () => import('@/views/swiper')

// 路由规则（无需修改）
const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
    meta: { pageKey: 'home' }
  },
  {
    path: '/news',
    name: 'news',
    component: news,
    meta: { pageKey: 'news' }
  },
  {
    path: '/news/:page',
    name: 'newspage',
    component: news,
    meta: { pageKey: 'news' },
    props: (route) => ({
      page: parseInt(route.params.page) || 1
    })
  },
  {
    path: '/news/class:classid',
    name: 'newsclass',
    component: news,
    meta: { pageKey: 'news' },
    props: (route) => ({
      classid: parseInt(route.params.classid) || 0,
      page: 1
    })
  },
  {
    path: '/news/class:classid/:page/',
    name: 'newsclasspage',
    component: news,
    meta: { pageKey: 'news' },
    props: (route) => ({
      classid: parseInt(route.params.classid) || 0,
      page: parseInt(route.params.page) || 1
    })
  },
  {
    path: '/newsshow/:classid/:id',
    name: 'newsshow',
    component: newsshow,
    meta: { pageKey: 'news' },
    props: (route) => ({
      classid: parseInt(route.params.classid) || 0,
      id: parseInt(route.params.id) || 0
    })
  },
  {
    path: '/service',
    name: 'service',
    component: service,
    meta: { pageKey: 'service' }
  },
  {
    path: '/strength',
    name: 'strength',
    meta: { pageKey: 'strength' },
    component: strength
  },
  {
    path: '/about', 
    name: 'about',
    component: about,
    meta: { pageKey: 'about' }
  },
  {
    path: '/swiper', 
    name: 'swiper',
    component: swiper,
    meta: { pageKey: 'swiper' }
  },
  {
    path: '/contact', 
    name: 'contact',
    component: contact,
    meta: { pageKey: 'contact' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

// 创建路由实例并添加滚动行为
const router = createRouter({
  // 2. 核心修改：把 createWebHashHistory 换成 createWebHistory（适配 Vue3 + Vite）
  history: createWebHistory(import.meta.env.BASE_URL), // 替换 process.env.BASE_URL 为 import.meta.env.BASE_URL（Vite 环境变量）
  routes,
  
  // 滚动行为（无需修改）
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0, left: 0, behavior: 'smooth' }
  }
})

export default router